import React, { createContext, useContext, useState, useEffect } from 'react';
import { getAllOrg, getOrgFarmers, questionAnalytics } from '../api';
import { clearUserData } from '../utils';
import { toast } from 'react-toastify';

const AppContext = createContext();

export const AppProvider = ({ children }) => {
    const [user, setUser] = useState(JSON.parse(localStorage.getItem('user') || '{}'));
    const [orgList, setOrgList] = useState([]);
    const [selectedOrg, setSelectedOrg] = useState(null);
    const [loading, setLoading] = useState(false);
    const [isUser, setIsUser] = useState(false);
    const [farmList, setFarmList] = useState([]);
    // console.log("🚀 ~ AppProvider ~ farmList:", farmList)
    const [selectedFarm, setSelectedFarm] = useState(null);
    const [graphsData, setGraphsData] = useState([]);

    useEffect(() => {
        if (user?.role === 'super_admin') {
            setLoading(true);
            getAllOrg()
                .then(response => {
                    // console.log("🚀 ~ useEffect ~ response:", response)
                    const dropdownOrg = response?.org_list?.map((org) => ({
                        id: org?._id,
                        name: org?.org?.org_name
                    }));
                    // dropdownOrg.unshift({ id: 'all', name: 'All Organizations' });
                    setOrgList(dropdownOrg);
                })
                .catch((error) => {
                    console.error("Error fetching organizations:", error);
                })
                .finally(() => {
                    setLoading(false);
                });
        }
        if (user?.role === 'admin') {
            setSelectedOrg(user?._id)
        }
        setIsUser(user?.role === 'farmer' || user?.role === 'super_admin' || user?.role === 'admin');
    }, [user]);

    useEffect(() => {

        if (user?.role === 'super_admin' || user?.role === 'admin') {
            setLoading(true);

            // Get the graph data for the selected org and farmer
            questionAnalytics({ org_id: selectedOrg === 'all' ? null : selectedOrg, farmer_id: selectedFarm === 'all' ? null : selectedFarm })
                .then(response => {
                    // console.log('response - ', response)
                    setGraphsData(response?.response ?? [])
                })
                .catch(error => {
                    setGraphsData([])
                    toast.error('Error fetching graph data:', error);
                    console.error('Error fetching graph data:', error);
                })
                .finally(() => {
                    setLoading(false);
                })
        }
    }, [selectedOrg, selectedFarm])

    useEffect(() => {
        setLoading(true);
        // Get all the farmers of the selected org
        getOrgFarmers(selectedOrg)
            .then(response => {
                // console.log("🚀 ~ useEffect ~ getOrgFarmers:", response)
                const dropdownOrg = response?.farmer_list?.farmer_list?.map((farmer) => ({
                    id: farmer?._id,
                    name: farmer?.farmer?.farm?.farm_name ?? 'N/A'
                }));
                setFarmList(dropdownOrg
                    || []);
            })
            .catch(error => {
                console.error("Error fetching farms:", error);
                setFarmList([]);
            })
            .finally(() => {
                setLoading(false);
            });
    }, [selectedOrg]);

    const updateUser = (newUser) => {
        setUser(newUser);
        localStorage.setItem('user', JSON.stringify(newUser));
    };

    const logout = () => {
        clearUserData();
        setUser(null);
        //   navigate('/login');
    };

    const value = {
        user,
        updateUser,
        logout,
        orgList,
        selectedOrg,
        setSelectedOrg,
        loading,
        setLoading,
        isUser,
        farmList,
        setFarmList,
        selectedFarm,
        setSelectedFarm,
        graphsData,
    };

    return (
        <AppContext.Provider value={value}>
            {children}
        </AppContext.Provider>
    );
};

export const useApp = () => {
    const context = useContext(AppContext);
    if (!context) {
        throw new Error('useApp must be used within an AppProvider');
    }
    return context;
}; 